<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            Credit Records
            <v-spacer></v-spacer>
            <ReturnHomeBtn />
            <AccountCreditChip :key="updateKey" />

            <v-dialog v-model="dialog" persistent max-width="490">
              <template v-slot:activator="{ on }">
                <CheckOutBtn v-if="isAdmin" />
                <v-btn color="primary" dark class="ml-3 mr-3 my-2" v-on="on">
                  <v-icon left>mdi-cash-usd-outline</v-icon>Add Credit Record
                </v-btn>
              </template>
              <v-form ref="form" lazy-validation>
                <v-card>
                  <v-card-title>
                    <span class="headline">Add Credit Record</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col>
                          <v-radio-group v-model="editedItem.recordType" row>
                            <v-radio label="Credit" value="Credit"></v-radio>
                            <v-radio label="Debit" value="Debit"></v-radio>
                          </v-radio-group>
                        </v-col>
                        <v-col>
                          <v-text-field
                            v-model="editedItem.amount"
                            type="number"
                            label="Amount"
                            prefix="$"
                            clearable
                            :rules="amountRules"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-textarea
                            counter
                            outlined
                            label="Notes"
                            hint="Reason for the credit/debit"
                            :rules="rules"
                            v-model="editedItem.notes"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="close">Cancel</v-btn>
                    <v-btn color="primary" :disabled="editedItem.amount <= 0" @click="save">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-dialog>
          </v-card-title>
          <v-card-subtitle v-if="isAdmin">{{ account.firstName}} {{ account.lastName }}</v-card-subtitle>
          <v-data-table
            :loading="!creditRecords"
            loading-text="Loading... Please wait"
            :headers="headers"
            :items="creditRecords"
            :expanded.sync="expanded"
            show-expand
          >
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">Notes: {{ item.notes }}</td>
            </template>
            <template v-slot:item.createdDate="{ item }">{{ item.createdDate | formatDateTime }}</template>
            <template v-slot:item.amount="{ item }">${{ item.amount }}</template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { errorMessageMixin } from "../shared";
import ReturnHomeBtn from "../components/ReturnHomeBtn.vue";
import AccountCreditChip from "../components/AccountCreditChip.vue";
import CheckOutBtn from "../components/CheckOutBtn.vue";

export default {
  name: "CreditRecords",
  mixins: [errorMessageMixin],
  components: { ReturnHomeBtn, AccountCreditChip, CheckOutBtn },

  async created() {
    console.log("credit records of ", this.account);
    await this.loadCreditRecords(this.account.id);
    this.$store.state.fullScreenLoading = false;
  },
  data() {
    return {
      headers: [
        { text: "Created Date", value: "createdDate", align: "start" },
        { text: "Type", value: "recordType" },
        { text: "Amount", value: "amount" },
        { text: "Admin Id", value: "adminId" },
        { text: "Admin Name", value: "adminName" },
        { text: "", value: "data-table-expand" }
      ],
      expanded: [],
      dialog: false,
      editedItem: {
        recordType: "Credit",
        amount: 0,
        notes: ""
      },
      defaultItem: {
        recordType: "Credit",
        amount: 0,
        notes: ""
      },
      rules: [v => v.length <= 500 || "Max 500 characters"],
      amountRules: [v => !v || v > 0 || "Must be positive"],
      updateKey: false
    };
  },
  computed: {
    ...mapState(["account", "creditRecords"]),
    ...mapGetters(["isAdmin", "user"])
  },
  methods: {
    ...mapActions([
      "getCreditRecordsAction",
      "addCreditRecordAction",
      "logout"
    ]),
    async loadCreditRecords(id) {
      try {
        await this.getCreditRecordsAction({
          id: id,
          token: this.$store.state.token
        });

        if (this.$store.state.creditRecords == null) {
          this.logout();
          console.log("im logged out");
          this.$router.go();
        }
      } catch (err) {
        this.$store.state.error = this.errorMessage(err);
        this.$store.state.snackbar = true;
        console.log(err);
      }
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      }, 300);
    },
    async save() {
      if (this.$refs.form.validate()) {
        if (
          confirm(
            "Create a " +
              this.editedItem.recordType +
              " record for $" +
              this.editedItem.amount +
              "?"
          )
        ) {
          console.log("im valid");
          this.$store.state.fullScreenLoading = true;
          try {
            let creditRecordModel = { ...this.editedItem };
            creditRecordModel.adminId = this.$store.state.user.id;
            creditRecordModel.adminName = this.$store.state.user.firstName;
            creditRecordModel.accountId = this.account.id;

            console.log("creditRecordModel", creditRecordModel);
            await this.addCreditRecordAction({
              model: creditRecordModel,
              token: this.$store.state.token
            });
          } catch (err) {
            this.$store.state.error = this.errorMessage(err);
            this.$store.state.snackbar = true;
            console.log(err);
          }
          this.$store.state.fullScreenLoading = false;
          this.dialog = false;
          this.updateKey = !this.updateKey;
        }
      }
    }
  }
};
</script>